import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { getOptions } from '../components/options/verbrauch';
import { data } from '../components/data/verbrauch';
import { verbrauch } from '../components/objects/verbrauch';
import { StatCard, StatCardSkeleton } from '../components/solar/StatCard';
import { ChartCardWithPagination } from '../components/solar/ChartCardWithPagination';
import { Bar } from 'react-chartjs-2';
import { Card } from 'react-bootstrap';

class VerbrauchClass extends Component {

    static getDerivedStateFromProps(nextProps, prevState) {
        const nextYear = parseInt(nextProps.match.params.Year) || 0;
        if (prevState.prevYear !== nextYear) {
            return { prevYear: nextYear, _fetchNeeded: true };
        }
        return null;
    }

    componentDidMount() {
        const Year = parseInt(this.props.match.params.Year) || 0;

        this.setState({ prevYear: Year }, () => {
            if (Year > 0) {
                verbrauch.VerbrauchClass.url = verbrauch.VerbrauchClass.defaultSegment + "/verbrauch/" + Year;
                verbrauch.VerbrauchClass.forceRefresh = true;
            }
            else {
                verbrauch.VerbrauchClass.url = verbrauch.VerbrauchClass.defaultSegment + "/verbrauch/" + new Date().getFullYear();
            }

            this.props.request(verbrauch["VerbrauchClass"]);
        });
    }

    componentDidUpdate() {
        if (this.state._fetchNeeded) {
            const nextYear = parseInt(this.props.match.params.Year) || 0;

            this.setState({ _fetchNeeded: false }, () => {
                if (nextYear > 0) {
                    verbrauch.VerbrauchClass.forceRefresh = true;
                    verbrauch.VerbrauchClass.url = verbrauch.VerbrauchClass.defaultSegment + "/verbrauch/" + nextYear;
                    this.props.request(verbrauch["VerbrauchClass"]);
                }
            });
        }
    }

    state = {};

    render() {
        return (
            <div>
                {renderKPIRow(this.props)}
                {renderUIGesamt(this.props)}
            </div>
        );
    }
}

/**
 * KPI-Zeile: Jahresgesamt, Solar-Anteil, Netzbezug, hoechster Monat
 */
function renderKPIRow(props) {
    const ui = props.VerbrauchUI || {};
    // BOTH isLoaded=true UND Daten vorhanden
    let hasData = typeof (ui.monat) !== 'undefined' && ui.monat.length > 0;

    if (!props.isLoaded || !hasData) {
        return (
            <div className="stat-cards-row">
                <StatCardSkeleton />
                <StatCardSkeleton variant="energy" />
                <StatCardSkeleton variant="progress" />
                <StatCardSkeleton />
            </div>
        );
    }

    const gesamtArr = ui.gesamtDataVerbrauch || [];
    const solarArr = ui.verbrauchData || [];
    const bezugArr = ui.bezugData || [];
    const monatArr = ui.monat || [];

    let jahrenGesamt = 0;
    let jahrenSolar = 0;
    let jahrenBezug = 0;

    for (let i = 0; i < gesamtArr.length; i++) {
        jahrenGesamt += Number(gesamtArr[i]) || 0;
        jahrenSolar += Number(solarArr[i]) || 0;
        jahrenBezug += Number(bezugArr[i]) || 0;
    }

    // Solar-Anteil in Prozent
    const solarAnteil = jahrenGesamt > 0
        ? Math.round((jahrenSolar / jahrenGesamt) * 100)
        : 0;

    // Hoechster Verbrauch im Monat
    let peakMonth = '-';
    let peakValue = 0;
    for (let i = 0; i < gesamtArr.length; i++) {
        const val = Number(gesamtArr[i]) || 0;
        if (val > peakValue) {
            peakValue = val;
            peakMonth = monatArr[i] || '-';
        }
    }

    return (
        <div className="stat-cards-row">
            <StatCard
                value={Math.round(jahrenGesamt)}
                label="Jahresverbrauch"
                unit=" kWh"
                icon={<i className="bi bi-lightning" />}
                subLabel={Math.round(jahrenGesamt).toLocaleString('de-DE') + ' kWh gesamt'}
            />
            <StatCard
                value={Math.round(jahrenSolar)}
                label="Solar-Anteil"
                unit=" kWh"
                icon={<i className="bi bi-sun" />}
                variant="energy"
                subLabel={solarAnteil + '% des Verbrauchs'}
            />
            <StatCard
                value={Math.round(jahrenBezug)}
                label="Netzbezug"
                unit=" kWh"
                icon={<i className="bi bi-plug" />}
                variant="progress"
                subLabel={Math.round(jahrenBezug).toLocaleString('de-DE') + ' kWh aus Netz'}
            />
            <StatCard
                value={Math.round(peakValue)}
                label={"hoechster Monat: " + peakMonth}
                unit=" kWh"
                icon={<i className="bi bi-graph-up-arrow" />}
                subLabel={Math.round(peakValue).toLocaleString('de-DE') + ' kWh in ' + peakMonth}
            />
        </div>
    );
}

function renderUIGesamt(props) {
    let VerbrauchUI = props.VerbrauchUI || {};

    // BOTH check: Skelett so lange zeigen, BIS isLoaded=true UND Daten vorhanden!
    let hasData = typeof (VerbrauchUI.monat) !== 'undefined' && VerbrauchUI.monat.length > 0;
    let loading = !props.isLoaded || !hasData;

    // Stacked-Bar-Chart: Solar (Gruen) + Bezug (Amber) gestapelt
    let chartData = { labels: [''], datasets: [{ data: [0] }, { data: [0] }] };

    if (hasData) {
        let labels = [];
        let dataverbrauch = [];
        let databezug = [];

        for (var i = 0; i < VerbrauchUI.monat.length; i++) {
            labels.push(VerbrauchUI.monat[i]);
            dataverbrauch.push(VerbrauchUI.verbrauchData[i]);
            databezug.push(VerbrauchUI.bezugData[i]);
        }

        chartData = {
            labels: labels,
            datasets: [
                { ...data.datasets[0], data: dataverbrauch },
                { ...data.datasets[1], data: databezug }
            ]
        };
    }

    return (
        <div>
            <h3>Jahres-Gesamtverbrauchsanalyse im Jahr {props.match?.params.Year || new Date().getFullYear()}</h3>
            <ChartCardWithPagination
                routeSegment={'verbrauch'}
                onlyYear={true}
                match={props.match}
                history={props.history}
                loading={loading}>
                <Card className="chart-card">
                    <Card.Body>
                        <Bar data={chartData} options={{ ...getOptions(), animation: false }} />
                    </Card.Body>
                </Card>
            </ChartCardWithPagination>
        </div>
    );
}

export default connect(
    state => state.verbrauchReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(VerbrauchClass);